import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 *  A beadandó- és online óra képernyők közös apróságai (backend/beadando.js).
 */

/**
 *  Külső link (online óra) megnyitása. Csak http(s): a kiszolgáló is csak ilyet ment, de a
 *  felület se nyisson meg mást. Appban a rendszerböngésző/in-app böngésző, weben új lap.
 */
export function kulsoLinkMegnyit(url: string): void {
  const u = String(url || '').trim();
  if (!/^https?:\/\//i.test(u)) return;
  if (Capacitor.isNativePlatform()) {
    Browser.open({ url: u }).catch(() => { try { window.open(u, '_blank', 'noopener'); } catch { /* ignore */ } });
    return;
  }
  try { window.open(u, '_blank', 'noopener'); } catch { /* ignore */ }
}

/** Fájlméret emberi alakban. */
export function meretKiir(b: number | null | undefined): string {
  const n = Number(b) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} kB`;
  return `${(n / 1024 / 1024).toLocaleString('hu-HU', { maximumFractionDigits: 1 })} MB`;
}

/** `YYYY-MM-DD HH:mm` → `YYYY. MM. DD. HH:mm`. */
export function idoKiir(v: string | null | undefined): string {
  const m = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  return m ? `${m[1]}. ${m[2]}. ${m[3]}. ${m[4]}:${m[5]}` : String(v || '');
}

/** A feltölthető kiterjesztések (a kiszolgáló ugyanezt ellenőrzi). */
export const ENGEDETT_FAJLOK = '.pdf,.doc,.docx,.odt,.rtf,.txt,.xls,.xlsx,.ods,.csv,.ppt,.pptx,.odp,.jpg,.jpeg,.png,.gif,.webp,.heic,.zip,.mp3,.m4a,.wav,.mp4,.mov,.ggb,.sb3';
